import { render, staticRenderFns } from "./NewFinder.vue?vue&type=template&id=60a99284&scoped=true"
import script from "./NewFinder.vue?vue&type=script&lang=js"
export * from "./NewFinder.vue?vue&type=script&lang=js"
import style0 from "./NewFinder.vue?vue&type=style&index=0&id=60a99284&prod&lang=scss&scoped=true"
import style1 from "./NewFinder.vue?vue&type=style&index=1&id=60a99284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a99284",
  null
  
)

export default component.exports